<template>
	<div class="area-template">
		<h1
			class="title-modal"
			:style="`color:${$appColors.primary}`"
		>
			{{ title }}
		</h1>
		<v-layout justify-space-between>
			<v-flex xs6 class="mt-2 message-error-container">
				<label class="new-survey-label">Nombre</label>
				<v-text-field
					label="Nombre"
					solo
					hide-details
					class="input-text"
					v-model="data.name"
				></v-text-field>
				<span
					v-if="$v.data.name.$invalid"
					class="message-error"
					:style="`color:${$appColors.error}`"
				>
					El nombre es requerido
				</span>
			</v-flex>
			<v-flex xs4 class="mt-2 message-error-container">
				<label class="new-survey-label">Código</label>
				<v-text-field
					label="Código"
					solo
					hide-details
					class="input-text"
					v-model="data.code"
				></v-text-field>
				<span
					v-if="!$v.data.code.required"
					class="message-error"
					:style="`color:${$appColors.error}`"
				>
					El código es requerido
				</span>
				<span
					v-if="!$v.data.code.maxLength"
					class="message-error"
					:style="`color:${$appColors.error}`"
				>
					El código debe tener máximo 4 caracteres
				</span>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';

function validations() {
	return {
		data: {
			name: { required },
			code: { required, maxLength: maxLength(4) },
		},
	};
}

export default {
	name: 'new-area',
	props: {
		data: {
			type: Object,
			default: () => {},
		},
		title: String,
		validation: {
			type: Object,
			default: () => {},
		},
	},
	validations,
};
</script>
<style lang="scss" scoped>
	.area-template {
		margin-bottom: 62px;
	}

	.title-modal {
		font-family: font(bold);
		font-size: size(xlarge);
	}

	.new-survey-label {
		color: color(tooltip-gray);
	}

	.message-error-container {
		position: relative;
	}

	.message-error {
		bottom: -15px;
		font-family: font(regular);
		font-size: size(small11);
		position: absolute;
		width: 100%;
	}
</style>






// WEBPACK FOOTER //
// src/components/configuration/new-area.vue